// Campaign form, Cloaked (iframe) mode: checks on its own whether the campaign
// Target URL may be shown in a frame. Clicks that no stream matches go there, and
// a page that forbids framing (Google, Facebook…) shows an empty screen.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../App';
import { useT } from '../i18n';

export default function IframeTargetWarning({ url = '' }) {
  const { t } = useT();
  const [state, setState] = useState(null);

  useEffect(() => {
    const value = (url || '').trim();
    setState(null);
    if (!/^https?:\/\/[^\s/]+\.[^\s]+$/i.test(value)) return undefined;
    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        const r = await axios.post(API + '/tools/frame-check', { url: value });
        if (!cancelled && r.data && r.data.frameable === false) {
          setState({ reason: r.data.reason || '' });
        }
      } catch (_e) {
        // The manual check below the field shows errors; stay quiet here.
      }
    }, 900);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [url]);

  if (!state) return null;
  return (
    <p className="text-xs text-red-400" data-testid="iframe-target-warning">
      {t('Target URL cannot be shown in a frame: clicks that no stream matches will see an empty screen. Put your own page there or choose another redirect mode.')}
      {state.reason ? ' — ' + state.reason : ''}
    </p>
  );
}
